<div class="container">
    <ng-container #componentContainer></ng-container>
    <div class="icons-layer" (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)"
        [ngClass]="{'control-selected':selectedControl&&selectedControl.id===config.id,'control-invalid':invalidControlId.includes(config.id)}">
        <div class="icon-left">
            <smart-icon name="switch" *ngIf="ableMoveLeft&&hover" class="small light" (click)="moveLeft($event)">
            </smart-icon>
        </div>
        <div class="icon-middle">
            <div class="icon-middle-top">
                <smart-icon name="moveup" *ngIf="ableMoveUp&&hover" class="small light" (click)="moveUp($event)">
                </smart-icon>
            </div>
            <div class="icon-middle-bottom">
                <smart-icon name="movedown" *ngIf="ableMoveDown&&hover" class="small light" (click)="moveDown($event)">
                </smart-icon>
            </div>
        </div>
        <div class="icon-right">
            <div class="icon-right-top">
                <smart-icon name="trash" *ngIf="hover" class="small light" (click)="onDelete($event)"></smart-icon>
            </div>
            <div class="icon-right-center">
                <smart-icon name="switch" *ngIf="ableMoveRight&&hover" class="small light" (click)="moveRight($event)">
                </smart-icon>
            </div>
            <div class="icon-right-bottom">
            </div>
        </div>
    </div>
</div>